(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('AdvertisingSourceSearch', AdvertisingSourceSearch);

    AdvertisingSourceSearch.$inject = ['$resource'];

    function AdvertisingSourceSearch($resource) {
        var resourceUrl =  'api/_search/advertising-sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
